import { AssetType, LoanStatus } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import {
  ALLOWED_LOAN_STATUSES_FOR_CANCELLED,
  ALLOWED_LOAN_STATUSES_FOR_CANCELLED_MERCHANT,
  ALLOWED_LOAN_STATUSES_FOR_CANCELLED_TEST,
  ALLOWED_LOAN_STATUSES_FOR_CANCELLED_TEST_MERCHANT,
} from '@/components/widgets/LoanDetailActions/constants/statusesLists';
import { GetLoanDetailActionsByRoleProps } from '@/components/widgets/LoanDetailActions/types/GetLoanDetailActionsByRoleProps';
import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';
import { APP_ROLES } from '@/config/config';

export const getLoanCancellationRelatedActions = ({
  toggleActionDialog,
  loan,
  role,
}: GetLoanDetailActionsByRoleProps) => {
  if (
    !(
      role === APP_ROLES.ADMIN ||
      role === APP_ROLES.SUPER_ADMIN ||
      role === APP_ROLES.LENDER ||
      role === APP_ROLES.MERCHANT ||
      role === APP_ROLES.CHANNEL ||
      role === APP_ROLES.AGENT ||
      role === APP_ROLES.CPC_BACK_OFFICE
    )
  )
    return [];

  if (loan.status === LoanStatus.STATUS_DENIED) return [];

  const isCancelDisabled = !(
    role === APP_ROLES.MERCHANT || role === APP_ROLES.CHANNEL || role === APP_ROLES.AGENT
      ? ALLOWED_LOAN_STATUSES_FOR_CANCELLED_MERCHANT
      : ALLOWED_LOAN_STATUSES_FOR_CANCELLED
  ).includes(loan.status);

  const isCancelTestDisabled = !(
    role === APP_ROLES.MERCHANT || role === APP_ROLES.CHANNEL || role === APP_ROLES.AGENT
      ? ALLOWED_LOAN_STATUSES_FOR_CANCELLED_TEST_MERCHANT
      : ALLOWED_LOAN_STATUSES_FOR_CANCELLED_TEST
  ).includes(loan.status);

  return [
    ...((role === APP_ROLES.ADMIN || role === APP_ROLES.SUPER_ADMIN || role === APP_ROLES.CPC_BACK_OFFICE) &&
    loan.assetReference[0].type !== AssetType.ORDER
      ? [
          {
            display: <Text tId={'DESIST'} />,
            onClick: () => toggleActionDialog(LoanDetailAction.DESIST),
            iconName: 'back_hand',
          },
        ]
      : []),
    {
      display: <Text tId={'CANCEL'} />,
      onClick: () => toggleActionDialog(LoanDetailAction.CANCEL),
      iconName: 'cancel',
      disabled: isCancelDisabled,
    },
    ...(role !== APP_ROLES.CPC_BACK_OFFICE
      ? [
          {
            display: <Text tId={'CANCEL_TEST'} />,
            onClick: () => toggleActionDialog(LoanDetailAction.CANCEL_TEST),
            iconName: 'cancel_presentation',
            disabled: isCancelTestDisabled,
          },
        ]
      : []),
  ];
};
